<div
  class="secondary-sidebar-container"
  [class.left-sidebar]="!rightSidebar"
  [class.right-sidebar]="rightSidebar"
  [ngClass]="{
    collapsed: isCollapsed,
  }"
>
  <div class="sidebar-header">
    <div class="header-content">
      <div class="header-info">
        <span class="title body-l">{{ title }}</span>
      </div>
      <ptl-button
        class="collapse-btn"
        type="tertiary-neutral"
        size="m"
        [icon]="LucideChevronsLeft"
        (click)="onToggleCollapse()"
      ></ptl-button>
    </div>
  </div>

  <div class="header-separator"></div>

  <a *ngIf="backLink" class="back-link" [routerLink]="backLink.url">
    <ptl-icon [icon]="LucideChevronLeft" [size]="'s'"></ptl-icon>
    <span>{{ backLink.label }}</span>
  </a>

  <div class="secondary-sidebar-content">
    <ng-content></ng-content>
  </div>

  <div class="secondary-sidebar-footer">
    <ng-content select="[sidebarFooter]"></ng-content>
  </div>
</div>
